import React, { useState, useEffect, useRef } from "react";
import { momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import { FormControl, Grid, TextField } from "@mui/material";
import { useHistory } from "react-router-dom";

//-------------------------------COMPONENTS-------------------------------------//
import BigCalendar from "../../components/BigCalendar/BigCalendar";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import CalendarPopup from "../../components/Popup/CalendarPopup";
import CalendarClickedPopup from "../../components/Popup/CalendarClickedPopup";
import MaintenanceType from "../../components/Dropdowns/MaintenanceType/MaintenanceType";
import Machine from "../../components/TextFields/Machine/Machine";

import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import ls from "local-storage";
import { useDispatch, useSelector } from "react-redux";

//-------------------------------ACTIONS-------------------------------------//
import { getList, getupdateTaskDate, getTaskDetailById, getListMaintenanceType, getTaskSchedule } from "../../store/actions/PlannedMaintenanceCalendarActions";
import { getShifts } from "../../store/actions/ShiftActions";

moment.locale("ko", {
    //korean
    week: {
        dow: 1, //represents that the week will start with Monday
        doy: 1, //'doy' works together with 'dow' to determine first week of the year.
    },
}); //calendar starts on monday

const localizer = momentLocalizer(moment);

const ss = sessionStorage;

const PlannedMaintenanceCalendar = () => {
    const dispatch = useDispatch();
    const [taskList, setTaskList] = useState([]);
    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const [updatedTask, setUpdatedTask] = useState(0);
    const [oldDate, setOldDate] = useState(null);
    const [newDate, setNewDate] = useState(null);
    const [defaultCalendarDate, setDefaultCalendarDate] = useState(new Date());
    const [calendarDate, setCalendarDate] = useState(defaultCalendarDate);
    const [calendarView, setCalendarView] = useState(Views.MONTH);
    const [clickedPopupIsOpen, setClickedPopupIsOpen] = useState(false);
    const [clickedEventId, setClickedEventId] = useState();
    const { t } = useTranslation("translation");
    const [filter, setFilter] = useState({
        startDate: moment(defaultCalendarDate).startOf("month").format("YYYY-MM-DD"),
        endDate: moment(defaultCalendarDate).endOf("month").format("YYYY-MM-DD"),
        machineId: 0,
        poolId: ls.get("pool_PlannedMaintenanceCalendar")?.poolId ?? 0,
        areaGroupId: 0,
        maintenanceTypeId: 0,
        shiftNos: parseInt(ls.get("pmc_shiftNo")) || [],
    });

    const isMounted = useRef(false);

    const PlannedMaintenanceCalendar = useSelector((state) => state.PlannedMaintenanceCalendar);
    const { shiftList } = useSelector(({ Shifts }) => Shifts);

    useEffect(() => {
        if (isMounted.current) LoadCalendarData();
        else isMounted.current = true;
    }, [filter]);

    useEffect(() => {
        if (PlannedMaintenanceCalendar.updateTaskDate) {
            let calenderData = taskList;
            
            if (updatedTask.id == PlannedMaintenanceCalendar.updateTaskDate.resultObject.id) {
                const date = new Date(PlannedMaintenanceCalendar.updateTaskDate.resultObject.plannedDate);
                const task = calenderData.filter((task) => task.id === updatedTask.id)[0];
                task.color = HandleBackgroundColor(task.status, newDate);
                task.start = new Date(date.toISOString().slice(0, -1));
                task.end = new Date(date.toISOString().slice(0, -1));
            }
            setTaskList(calenderData);
            setPopupIsOpen(false);
        }
    }, [PlannedMaintenanceCalendar.updateTaskDate]);

    useEffect(() => {
        if (PlannedMaintenanceCalendar.tasklist) {
            var objList = Object.values(PlannedMaintenanceCalendar.tasklist);
            let calenderData = [];
            objList.forEach((element) => {
                const start = new Date(element.plannedDate);
                const maintenanceType = element.maintenanceTypeName ? " - " + element.maintenanceTypeName : "";
                const end = new Date(element.plannedDate);
                const color = HandleBackgroundColor(element.taskStatus, end);
                calenderData.push({
                    id: element.id,
                    color: color,
                    status: element.taskStatus,
                    title: element.id + " - " + element.equipmentName + maintenanceType,
                    start: start,
                    end: end,
                });
            });
            setTaskList(calenderData);
        }
    }, [PlannedMaintenanceCalendar.tasklist]);

    useEffect(() => {
        if (PlannedMaintenanceCalendar.poolList) {
            setPoolData(PlannedMaintenanceCalendar.poolList);
        }
    }, [PlannedMaintenanceCalendar.poolList]);

    const [state, setState] = useState({
        pool: ls.get("pool_PlannedMaintenanceCalendar")?.poolId,
        poolName: ls.get("pool_PlannedMaintenanceCalendar")?.poolName,
        maintenanceType: null,
        maintenanceTypeName: null,
    });

    const LoadHandler = () => {
        LoadShiftData();
        LoadCalendarData();
        LoadPoolData();
        LoadMaintenanceTypesData();
    };

    const LoadShiftData = () => {
        dispatch(getShifts());
    };

    const HandleBackgroundColor = (status, end) => {
        if (status === 1) {
            if (new Date().setHours(0, 0, 0, 0) > end.setHours(0, 0, 0, 0)) {
                return "red";
            } else {
                return "orange";
            }
        } else if (status === 2) {
            return "#FFEA00";
        } else if (status === 3) {
            return "green";
        } else if (status === 4) {
            return "blue";
        } else {
            return "gray";
        }
    };

    const history = useHistory();

    useEffect(() => {
        if (PlannedMaintenanceCalendar.taskDetailById) {
            if (PlannedMaintenanceCalendar.taskDetailById.breakdownEffectId == undefined) {
                history.push("/create-planned-maintenance?from=calendar&id=" + PlannedMaintenanceCalendar.taskDetailById.maintenanceOrderId);
            }
            PlannedMaintenanceCalendar.taskDetailById = null;
        }
    }, [PlannedMaintenanceCalendar.taskDetailById]);

    useEffect(() => {
        if (PlannedMaintenanceCalendar.MaintainanceTypeList) {
            setMaintenanceTypes(PlannedMaintenanceCalendar.MaintainanceTypeList.resultObject);
        }
    }, [PlannedMaintenanceCalendar.MaintainanceTypeList]);

    useEffect(() => {
        LoadHandler();

        setState({
            pool: ls.get("pool_PlannedMaintenanceCalendar")?.poolId,
        });
    }, []);

    //load shift data
    let [shiftData, setShiftData] = useState([]);
    useEffect(() => {
        if (shiftList?.resultObject?.length > 0) {
            setShiftData(shiftList.resultObject[0].shifts);
        }
    }, [shiftList]);

    //set pool
    const HandlePool = (poolName) => {
        if (poolName != null) {
            const pool = poolData.find((item) => item.name === poolName);
            const poolId = pool?.id;

            setSelectedPool(poolId); //14
            setState({ ...state, pool: poolId, poolName: poolName });
            setFilter({
                ...filter,
                poolId: poolId,
            });

            ls.set("pool_PlannedMaintenanceCalendar", { poolId, poolName });
        } else {
            setState({ ...state, pool: "", poolName: "" }); //set to null when pool name equals to empty
            setFilter({
                ...filter,
                poolId: 0,
            });
            setSelectedPool();
            ls.remove("pool_PlannedMaintenanceCalendar"); //when pool name is empty, set selectedpool to null
        }
    };

    const LoadCalendarData = () => {
        dispatch(getTaskSchedule(filter));
    };

    const OnEventMovedHandler = (event, start, end) => {
        setUpdatedTask(event);
        setOldDate(event.start);
        setNewDate(end);
        setDefaultCalendarDate(end);
        if (moment(event.start).format("DD.MM.YYYY") !== moment(end).format("DD.MM.YYYY")) setPopupIsOpen(true);
        //drag and drop yapılan saatlerde vardiya değişikliği olursa popup açılacak
        if(moment(start).format("HH") !== moment(event.start).format("HH")){
            setPopupIsOpen(true);
        } 

        if (event.fromChild) {
            setUpdatedTask(event);
            setOldDate(start);
            setNewDate(end);
            setPopupIsOpen(true);
            setDefaultCalendarDate(end);
        }
    };

    const OnCloseHandler = () => {
        setPopupIsOpen(false);
    };

    const UpdateOnceHandler = () => {
        let payload = {
            newDate: new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000)).toISOString(),
            taskId: updatedTask.id,
        };
        dispatch(getupdateTaskDate(payload));
    };

    const OnEventClicked = (id) => {
        setClickedEventId(id);
        setClickedPopupIsOpen(true);
    };

    const OnClickedPopupCloseHandler = () => {
        setClickedPopupIsOpen(false);
    };

    const PushToDetailPage = () => {
        dispatch(getTaskDetailById(clickedEventId));
    };

    //load pool data
    const [selectedPool, setSelectedPool] = useState();
    const [poolData, setPoolData] = useState([]);
    const LoadPoolData = () => {
        dispatch(getList());
    };

    // maintenance types
    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState();
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState();
    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const LoadMaintenanceTypesData = () => {
        dispatch(getListMaintenanceType());
    };

    const HandleMaintenanceType = (maintenanceTypeName) => {
        const maintenanceType = maintenanceTypes.find((item) => item.name === maintenanceTypeName);
        const maintenanceTypeId = maintenanceType?.id;

        setFilter({
            ...filter,
            maintenanceTypeId: maintenanceTypeId,
        });

        setSelectedMaintenanceType(maintenanceTypeName);
        setSelectedMaintenanceTypeName(maintenanceTypeName);
    };

    const HandleShift = (shiftNo) => {
        let shiftNos = [];
        if (shiftNo != null) {
            shiftNo.map((item) => shiftNos.push(item.shiftNo.toString()));

            setFilter({
                ...filter,
                shiftNos: shiftNos,
            });
            //setState({ ...state, shiftIds: shiftIds });
            ls.set("pmc_shiftNo", shiftNos);
        }
    };

    // Machine popup
    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "pmc",
            selectedAreaCode: isCleared ? null : ss.getItem("pmc_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("pmc_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("pmc_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("pmc_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("pmc_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("pmc_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);

    useEffect(() => {
        setFilter({ ...filter, machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0, areaGroupId: machineStates.selectedAreaCode ?? 0 });
    }, [machineStates]);

    const handleCalendarNavigationChange = (date, view, action) => {
        var dateFilter = getDateFilterFromCalendarView(date, view);

        setCalendarDate(new Date(dateFilter.startDate));

        setFilter({
            ...filter,
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
        });
    };

    const getDateFilterFromCalendarView = (date, view) => {
        var range = view === Views.AGENDA ? "month" : view === Views.WORK_WEEK ? "week" : view;

        return {
            startDate: moment(date).startOf(range).format("YYYY-MM-DD"),
            endDate: moment(date).endOf(range).format("YYYY-MM-DD"),
        };
    };

    const handleCalendarViewChange = (newView) => {
        setCalendarView(newView);

        // var willFilterChange = false;
        // switch (calendarView) {
        //     case Views.MONTH:
        //         return;
        //     case Views.DAY:
        //     case Views.WEEK:
        //         if (newView !== Views.DAY) willFilterChange = true;
        //         break;
        // }
        // if (!willFilterChange) return;

        var dateFilter = getDateFilterFromCalendarView(calendarDate, newView);
        setFilter({
            ...filter,
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
        });
    };

    return (
        <div>
            <div style={{ height: "74%", width: "100%" }}>
                <Grid container id="pmc_Grid_1" justifyContent="center">
                    <Grid id="pmc_Grid_2" item xs={3} style={{ marginTop: 4 }}>
                        <FormControl id="pmc_FormControl_0" variant="outlined" style={{ width: "90%" }}>
                            <Autocomplete
                                id="pmc_Autocomplete_0"
                                onChange={(event, newValue) => {
                                    HandlePool(newValue);
                                }}
                                value={state.poolName != null ? state.poolName : ls.get("pool_PlannedMaintenanceCalendar") ? ls.get("pool_PlannedMaintenanceCalendar").poolName : null}
                                defaultValue=""
                                options={poolData.map((option) => option.name)}
                                renderInput={(params) => <TextField {...params} margin="normal" label={t("Pool")} variant="outlined" />}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item id="pmc_Grid_3" xs={3} style={{ marginTop: 4 }}>
                        <FormControl id="pmc_FormControl_1" variant="outlined" style={{ width: "90%" }}>
                            <MaintenanceType
                                id="PMC_mtype"
                                selectedMaintenanceTypeName={selectedMaintenanceTypeName}
                                HandleMaintenanceTypeChange={HandleMaintenanceType}
                                maintenanceTypes={maintenanceTypes}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item id="pmc_Grid_4" xs={3} style={{ marginTop: 4 }}>
                        <FormControl id="pmc_FormControl_2" variant="outlined" style={{ width: "90%" }}>
                            <Machine setMachineStates={setMachineStates} machineStates={machineStates} size="normal" />
                        </FormControl>
                    </Grid>
                    <Grid id="ps_Grid_2" item xs={3} style={{ marginTop: 4 }}>
                        <FormControl id="ps_formControl_1" variant="outlined" style={{ width: "90%" }}>
                            <Autocomplete
                                id="cpm_Shift_Autocomplete"
                                multiple
                                options={shiftData}
                                limitTags={5}
                                value={shiftData.filter((item) => ls.get("pmc_shiftNo")?.includes(item.shiftNo.toString()))}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option.shiftNo.toString()}
                                renderInput={(params) => <TextField id="pmc_TextField_5" {...params} margin="normal" label={t("Shift")} variant="outlined" />}
                                onChange={(event, newValue) => {
                                    HandleShift(newValue);
                                }}
                                renderOption={(_props, option) => <li {..._props}>{option.shiftNo.toString()}</li>}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <BigCalendar
                    id="pmc_bc"
                    events={taskList}
                    localizer={localizer}
                    onEventMoved={OnEventMovedHandler}
                    defaultDate={defaultCalendarDate}
                    date={calendarDate}
                    onClick={OnEventClicked}
                    onNavigate={handleCalendarNavigationChange}
                    onView={handleCalendarViewChange}
                    view={calendarView}
                />
            </div>

            {oldDate != null && newDate != null && popupIsOpen ? (
                <CalendarPopup id="pmc_cp" oldDate={moment(oldDate).format("DD.MM.YYYY HH:mm:ss")} newDate={moment(newDate).format("DD.MM.YYYY HH:mm:ss")} open={popupIsOpen} onClose={OnCloseHandler} updateOnce={UpdateOnceHandler} />
            ) : null}

            {clickedPopupIsOpen ? (
                <CalendarClickedPopup
                    id="pmc_ccp"
                    open={clickedPopupIsOpen}
                    onClose={OnClickedPopupCloseHandler}
                    pushToDetails={() => {
                        history.push("/planned-maintenance-detail?id=" + clickedEventId);
                    }}
                    pushToUpdate={PushToDetailPage}
                />
            ) : null}

            <LoadingBackdrop id="pmc_lbd" />
        </div>
    );
};

export default PlannedMaintenanceCalendar;
